// Kacheln unter „Mehr“ (rechnung/Mehr.tsx) für Billtoro: Zeiten, Lager und Tarif für alle; Team und Steuerbüro richtet nur der
// Inhaber ein. Ein Team-Mitglied sieht „Team“ (wer mitarbeitet, Firma verlassen), aber nicht „Steuerbüro“. Fehlt die
// Funktion im Tarif, sagt der Text, ab welchem Tarif es sie gibt. Ohne Tarif (Übersicht noch nicht da) alle fünf.
import { fehlendeFunktion, planName } from './upgrade';
import type { Tarif } from './types';

export function billtoroKacheln(tarif: Tarif | null | undefined): [string, string, string][] {
  const mitglied = tarif?.rolle === 'mitglied';
  const ab = (f: 'zeiten' | 'lager' | 'team' | 'steuerbuero', text: string) => {
    const fehlt = fehlendeFunktion(tarif, f);
    return fehlt && fehlt !== 'bald' && tarif ? `${text} · ab ${planName(tarif, fehlt)}` : text;
  };
  return [
    ['/rechnung/zeiten', 'Zeiten', ab('zeiten', 'Stunden für Kunden erfassen, mit der Uhr oder von Hand, und in Rechnungen übernehmen')],
    ['/rechnung/lager', 'Lager', ab('lager', 'Bestand je Artikel, Zugänge und Zählung')],
    ['/rechnung/tarif', 'Tarif & Bezahlung', mitglied ? 'Tarif dieser Firma und was er enthält' : 'Ihr Tarif, Zahlungsart und Rechnungen von Billtoro'],
    ['/rechnung/team', 'Team', mitglied ? 'Wer in dieser Firma mitarbeitet' : ab('team', 'Kolleginnen und Kollegen einladen, die mitarbeiten')],
    ...(mitglied
      ? []
      : ([['/rechnung/steuerbuero', 'Steuerbüro', ab('steuerbuero', 'Rechnungen jeden Monat ans Steuerbüro, auf Wunsch mit eigenem Zugang')]] as [string, string, string][])),
  ];
}
